import React, { useState, useEffect } from "react";
import ChangeAddress from "../ChangeAddress/ChangeAddress";
import ChangeEmail from "./ChangeEmail"
import TextInput from "../TextInput/TextInput";
import styles from "./AccountInfo.module.css";
import axios from "axios";
import { validateEmail } from "../utils/common";

const AccountInfo = ({ settingsOptionSelected, setSettingsOptionSelected, font }) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const [businessName, setBusinessName] = useState('');
	const [companyName, setCompanyName] = useState('');
	const [businessEmail, setBusinessEmail] = useState('');
	const [addressOne, setAddressOne] = useState('');
	const [addressTwo, setAddressTwo] = useState('');
	const [logisticsProviderCode, setLogisticsProviderCode] = useState('');
	const token = localStorage.getItem("authToken");
	const [editAddress, setEditAddress] = useState(false);
	const [editEmail, setEditEmail] = useState(false);
	const [fullAddress, setFullAddress] = useState('');
	const [alternateStreet, setAlternateStreet] = useState('');
	const [verified, setVerified] = useState(false);
	const [showChangesSavedMessage, setShowChangesSavedMessage] = useState(false);

	const saveChanges = async () => {
	    const payload = {
	        business_name: businessName.trim(),
	        business_email: businessEmail.trim(),
	        address: fullAddress.trim(), // The formatted Google address
	        street2: alternateStreet.trim(),
	        logistics_provider_code: logisticsProviderCode.trim(),
	    };
	    try {
	        const response = await axios.put(
	            `${apiUrl}/api/update_business_details/`,
	            payload,
	            {
	                headers: {
	                    "Content-Type": "application/json",
	                    "Authorization": `Bearer ${token}`,
	                },
	            }
	        );
	        if (response.status === 200) { setShowChangesSavedMessage(true); }
	    } catch (error) { console.error("Error updating business details:", error); }
	};

	useEffect(() => {
		const fetchBusinessDetails = async () => {
			try {
				const response = await axios.get(`${apiUrl}/api/business_details/`, {
					headers: {
						"Content-Type": "application/json",
						"Authorization": `Bearer ${token}`,
					},
				});
				const data = response.data;
				const fullAddress = `${data.street1},${data.street2 ? ' ' + data.street2 + ',' : ''} ${data.city}, ${data.state} ${data.zip_code}, ${data.country}`;
				setBusinessName(data.business_name);
				setCompanyName(data.company_name);
				if (editEmail !== "confirm_email") { setBusinessEmail(data.business_email); }
				setFullAddress(fullAddress);
				setAlternateStreet(data.street2 || '');
				setLogisticsProviderCode(data.logistics_provider_code || '');
				setVerified(data.verified);
			} catch (error) { console.error("Error fetching business details:", error); }
		};
		fetchBusinessDetails();
	}, [editEmail]);

	return (
		<>
			{editEmail && editEmail !== "confirm_email" && (<ChangeEmail editEmail={editEmail} setEditEmail={setEditEmail} businessEmail={businessEmail} setBusinessEmail={setBusinessEmail} font={font} />)}	
			{editAddress && (
				<div className={styles.change_address_wrapper}>
					<ChangeAddress setNewAddress={(newAddress) => { setFullAddress(newAddress); setEditAddress(false); }} />
					<button onClick={() => setEditAddress(false)} className={`back_buttons ${styles.settings_back_button} ${styles.move_up}`}>
						<img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={styles.settings_back_button_arrow} alt="back"/>
					</button>
				</div>
			)}
			{(!editEmail || editEmail === "confirm_email") && !editAddress && (
				<div className={`${styles.account_info_container} ${font}`}>
					<p className={`titles ${styles.account_info_title}`}>Account info</p>
					{showChangesSavedMessage && (<p className={`${styles.changes_saved_message} ${companyName ? styles.move_up : ""}`}>Changes saved.</p>)}
					<p className={styles.business_title}><span style={{fontWeight: "bold"}}>Business name:</span>&nbsp;&nbsp;{businessName}</p>
					{companyName && (<p className={styles.company_title}><span style={{fontWeight: "bold"}}>Company name:</span>&nbsp;&nbsp;{companyName}</p>)}
					<div className={styles.account_info_field_wrapper}>
						<TextInput inputType={"new_email"} value={businessEmail} onChange={(e) => setBusinessEmail(e.target.value)} required={false} readOnly={true} />
						<div className={styles.edit_account_info_button} onClick={() => {setEditEmail(true); setShowChangesSavedMessage(false);}}>Edit</div>
					</div>
					<div className={styles.account_info_field_wrapper}>
						<TextInput inputType={"new_address"} value={fullAddress} onChange={(e) => setFullAddress(e.target.value)} required={false} readOnly={true} />
						<div className={styles.edit_account_info_button} onClick={() => {setEditAddress(true); setShowChangesSavedMessage(false);}}>Edit</div>
					</div>
					<div className={styles.account_info_field_wrapper}>
						<TextInput inputType={"street2"} value={alternateStreet} onChange={(e) => setAlternateStreet(e.target.value)} required={false} />
					</div>
					<div className={styles.account_info_field_wrapper}>
						<TextInput inputType={"logistics_provider_code"} value={logisticsProviderCode} onChange={(e) => setLogisticsProviderCode(e.target.value)} required={false} />
						{verified &&(<img src={`${process.env.PUBLIC_URL}/images/verified.png`} className={styles.verified_icons} alt="verified"/>)}
					</div>
					<div className={`login_buttons ${styles.save_changes}`} onClick={() => saveChanges()}>Save changes</div>
					<button onClick={() => setSettingsOptionSelected("settings_back")} className={`back_buttons ${styles.settings_back_button}`}>
						 <img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={styles.settings_back_button_arrow} alt="back"/>
					</button>
				</div>
			)}
		</>
	);
};

export default AccountInfo;